module.exports = __webpack_public_path__ + "next.png?6e453a3f0cada1cec8045ae6a9a392ee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/layout/next.png
// module id = 40
// module chunks = 0